module.exports = __webpack_public_path__ + "static/media/strefa-relaxu.f03759cf.svg";